import { INVOICE_STATUS } from 'settings/constants/billing'
import T from 'T'

const { PARTIAL, UNPAID, PAID } = INVOICE_STATUS

const normalize = s => s?.toUpperCase?.() || ''

/**
 * Get the action label based on status transition between versions.
 * @param {string} currentStatus - Current invoice status
 * @param {string} previousStatus - Previous invoice status (can be undefined for first version)
 * @param {string} revType - Revision type (INSERT or UPDATE)
 * @returns {string} Action label describing what happened
 */
export const getActionLabel = (currentStatus, previousStatus, revType) => {
  // For INSERT (first version), use "Created" action
  if (revType === 'INSERT') {
    return T.CREATED
  }

  // Normalize statuses for comparison (handle both uppercase and capitalized)
  const prevNorm = normalize(previousStatus)
  const currNorm = normalize(currentStatus)
  const unpaidNorm = normalize(UNPAID)
  const partialNorm = normalize(PARTIAL)
  const paidNorm = normalize(PAID)

  // Draft (Partial) is the "unposted" state, UNPAID is "posted"
  // Transition from UNPAID -> PARTIAL = "Reverted to draft"
  if (prevNorm === unpaidNorm && currNorm === partialNorm) {
    return T.REVERTED_TO_DRAFT
  }

  // Transition from PARTIAL -> UNPAID = "Posted"
  if (prevNorm === partialNorm && currNorm === unpaidNorm) {
    return T.POSTED
  }

  // Transition from PARTIAL -> PAID = "Posted & Paid"
  if (prevNorm === partialNorm && currNorm === paidNorm) {
    return T.POSTED_AND_PAID
  }

  // Transition from UNPAID -> PAID = "Paid"
  if (prevNorm === unpaidNorm && currNorm === paidNorm) {
    return T.PAID
  }

  // Transition from PAID -> UNPAID = "Payment removed"
  if (prevNorm === paidNorm && currNorm === unpaidNorm) {
    return T.PAYMENT_REMOVED
  }

  // Transition from PAID -> PARTIAL = "Reverted to draft"
  if (prevNorm === paidNorm && currNorm === partialNorm) {
    return T.REVERTED_TO_DRAFT
  }

  // Default: generic "Updated"
  return T.UPDATED
}